{
  "actions": {
    "add": "Add",
    "open": "Open",
    "openType": "Open {{type, lowercase}}",
    "edit": "Edit",
    "remove": "Remove",
    "abort": "Cancel",
    "close": "Close",
    "create": "Create",
    "createNew": "Create new {{documentType}}",
    "search": "Search",
    "sort": "Sort",
    "sortBy": "Sort by {{label}}",
    "presetSort": "Preset sorting",
    "grouping": "Choose grouping",
    "nogrouping": "No grouping",
    "group": "Group",
    "copy": "Copy",
    "confirm": "Done",
    "markAsDone": "Mark as done",
    "move": "Move",
    "yes": "Yes",
    "no": "No",
    "approve": "Approve",
    "saveType": "Save {{type}}",
    "save": "Save",
    "publish": "Publish"
  },
  "misc": {
    "unknown": "unknown",
    "user": "user",
    "numberOf": "Number of",
    "from": "From",
    "new": "New",
    "selected": "selected",
    "since": "since",
    "missing": "missing",
    "loading": "Loading...",
    "titleMissing": "Title missing",
    "fetchingSession": "Fetching session...",
    "fetchingUserData": "Fetching user data...",
    "headingAndContent": "Heading and content",
    "markedAsCancelled": "Marked as cancelled",
    "error": "Error",
    "selectTime": "Select time",
    "searching": "Searching...",
    "nothingFound": "Nothing found"
  }
}
